declare global {
  interface Window {
    SENTRY_DSN: string | null;
    SENTRY_RELEASE: string | null;
    SENTRY_BROWSER_TRACES_SAMPLE_RATE: number | null;
  }
}

export const SENTRY_DSN =
  typeof window !== "undefined" ? window.SENTRY_DSN : null;

export const SENTRY_BROWSER_TRACES_SAMPLE_RATE =
  typeof window !== "undefined"
    ? window.SENTRY_BROWSER_TRACES_SAMPLE_RATE
    : null;

export const SENTRY_RELEASE =
  typeof window !== "undefined" ? window.SENTRY_RELEASE : null;
